const PAYMENT_STATUS = {
  PAYMENT: [1, 'Thanh toán'],
  NOT_IDEN: [2, 'Bổ sung CMND'],
  NOT_CONTRACT: [3, 'Bổ sung hợp đồng'],
  NOT_ADDENDUM: [4, 'Bổ sung phụ lục'],
};

export { PAYMENT_STATUS };
